(function () {
  'use strict';

  /* ── State ── */
  var activePanel = null;
  var closeTimer  = null;

  /* ── Open panel ── */
  window.ftOpenPanel = function (id, navItem) {
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }

    // Hide all panels & deactivate all nav items
    document.querySelectorAll('.ft-panel').forEach(function (p) {
      p.style.display = 'none';
    });
    document.querySelectorAll('.ni').forEach(function (n) {
      n.classList.remove('open');
    });

    var panel = document.getElementById(id);
    if (panel) {
      panel.style.display = 'block';
      activePanel = id;
    }
    if (navItem) navItem.classList.add('open');
  };

  /* ── Keep panel open (mouse is inside panel) ── */
  window.ftKeepPanel = function (id) {
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
  };

  /* ── Close panel with small delay ── */
  // window.ftClosePanel = function () {
  //   closeTimer = setTimeout(function () {
  //     document.querySelectorAll('.ft-panel').forEach(function (p) {
  //       p.style.display = 'none';
  //     });
  //     document.querySelectorAll('.ni').forEach(function (n) {
  //       n.classList.remove('open');
  //     });
  //     activePanel = null;
  //   }, 120);
  // };

  (function () {

  let closeTimer = null;

  // OPEN PANEL
  window.ftOpenPanel = function(id, navItem){

    clearTimeout(closeTimer);

    // remove all open
    document.querySelectorAll('.ft-panel').forEach(panel => {
      panel.style.display = 'none';
    });

    document.querySelectorAll('.ni').forEach(item => {
      item.classList.remove('open');
    });

    // open current
    const panel = document.getElementById(id);

    if(panel){
      panel.style.display = 'block';
    }

    // add active class
    const link = navItem.querySelector('.ni');

    if(link){
      link.classList.add('open');
    }

  };

  // KEEP OPEN
  window.ftKeepPanel = function(){
    clearTimeout(closeTimer);
  };

  // CLOSE
  window.ftClosePanel = function(){

    clearTimeout(closeTimer);

    closeTimer = setTimeout(() => {

      document.querySelectorAll('.ft-panel').forEach(panel => {
        panel.style.display = 'none';
      });

      document.querySelectorAll('.ni').forEach(item => {
        item.classList.remove('open');
      });

    }, 220);

  };

})();

  /* ── Close when clicking outside ── */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.ft-nav') && !e.target.closest('.ft-panel')) {
      document.querySelectorAll('.ft-panel').forEach(function (p) {
        p.style.display = 'none';
      });
      document.querySelectorAll('.ni').forEach(function (n) {
        n.classList.remove('open');
      });
      activePanel = null;
    }
  });

  /* ── Close on Escape key ── */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.ft-panel').forEach(function (p) {
        p.style.display = 'none';
      });
      document.querySelectorAll('.ni').forEach(function (n) {
        n.classList.remove('open');
      });
      activePanel = null;
    }
  });

  /* ── Close panel on page scroll ── */
  window.addEventListener('scroll', function () {
    var open = document.querySelector('.ft-panel[style*="block"]');
    if (open) ftClosePanel();
  }, { passive: true });

  /* ── Sticky nav shadow on scroll ── */
  window.addEventListener('scroll', function () {
    var nav = document.getElementById('ftNav');
    if (nav) {
      nav.classList.toggle('scrolled', window.scrollY > 10);
    }
  }, { passive: true });

})();






document.addEventListener("DOMContentLoaded", function () {

  const nav = document.querySelector("#ftNav");
  const overlay = document.getElementById("ftSearch");
  const input = document.getElementById("ftSearchInput");
  const resultsBox = document.getElementById("ftSearchResults");

  // OPEN
  if (nav) {
    nav.addEventListener("search-open", () => {
      overlay.classList.add("active");
      setTimeout(() => input.focus(), 200);
    });
  }

  // CLOSE
  window.ftCloseSearch = function () {
    overlay.classList.remove("active");
    resultsBox.innerHTML = "";
    input.value = "";
  };

  let timer;

  input.addEventListener("input", function () {
    clearTimeout(timer);

    const query = this.value.trim();

    if (query.length < 2) {
      resultsBox.innerHTML = "";
      return;
    }

    timer = setTimeout(() => {

      fetch(`/search/suggest.json?q=${query}&resources[type]=product,collection,article`)
        .then(res => res.json())
        .then(data => {

          const results = data.resources.results;

          let html = `<div class="search-grid">`;

          // 🔹 COLLECTIONS
          html += `<div class="search-grid-collection">
                    <h4>COLLECTIONS</h4>`;

          if (results.collections.length > 0) {
            results.collections.forEach(item => {
              html += `<a href="${item.url}" class="search-link">${item.title}</a>`;
            });
          } else {
            html += `<p class="empty">No collections found</p>`;
          }

          html += `</div>`;


          // 🔹 PRODUCTS
          html += `<div class="search-grid-product">
                    <h4>PRODUCTS</h4>`;

          if (results.products.length > 0) {
            results.products.forEach(product => {
              html += `
                <a href="${product.url}" class="search-product-item">
                  <img src="${product.image}" alt="">
                  <div>
                    <p>${product.title}</p>
                    <span>${product.price}</span>
                  </div>
                </a>
              `;
            });
          } else {
            html += `<p class="empty">No products found</p>`;
          }

          html += `</div>`;


          // 🔹 ARTICLES
          html += `<div class="search-grid-article">
                    <h4>ARTICLES</h4>`;

          if (results.articles.length > 0) {
            results.articles.forEach(article => {
              html += `
                <a href="${article.url}" class="search-article-item">
                  <img src="${article.image}" alt="">
                  <span>${article.title}</span>
                </a>
              `;
            });
          } else {
            html += `<p class="empty">No articles found</p>`;
          }

          html += `</div>`;

          html += `</div>`;

          resultsBox.innerHTML = html;

        })
        .catch(err => {
          console.log("Search error:", err);
        });

    }, 300);
  });

});



// mobileDrawer js
document.addEventListener("DOMContentLoaded", function () {

  /* ===============================
     MENU DRAWER OPEN / CLOSE
  =============================== */

  const openBtn = document.querySelector(".custom-menu-toggle");
  const drawer = document.querySelector("#mobileDrawer");
  const closeBtn = document.querySelector(".drawer-close");

  if (openBtn && drawer) {
    openBtn.addEventListener("click", function () {
      drawer.classList.add("active");
    });
  }

  if (closeBtn && drawer) {
    closeBtn.addEventListener("click", function () {
      drawer.classList.remove("active");
    });
  }

  /* ===============================
     SUBMENU TOGGLE (MAIN LOGIC 🔥)
  =============================== */

  const menuLinks = document.querySelectorAll(".has-children > a");

  menuLinks.forEach(link => {

    link.addEventListener("click", function (e) {

      const parent = this.parentElement;

      // agar submenu hai tabhi stop kare
      if (parent.classList.contains("has-children")) {
        e.preventDefault(); // 🔥 redirect stop
      }

      // Accordion: same level ke dusre band karo
      const siblings = parent.parentElement.querySelectorAll(".has-children");
      siblings.forEach(item => {
        if (item !== parent) {
          item.classList.remove("open");
        }
      });

      // toggle current
      parent.classList.toggle("open");

    });

  });

  /* ===============================
     SUB-CHILD SUPPORT (LEVEL 2+)
  =============================== */

  const childLinks = document.querySelectorAll(".submenu .has-children > a");

  childLinks.forEach(link => {

    link.addEventListener("click", function (e) {

      const parent = this.parentElement;

      e.preventDefault();

      // close siblings
      const siblings = parent.parentElement.querySelectorAll(".has-children");
      siblings.forEach(item => {
        if (item !== parent) {
          item.classList.remove("open");
        }
      });

      parent.classList.toggle("open");

    });

  });

  /* ===============================
     CLICK OUTSIDE → CLOSE DRAWER
  =============================== */

  document.addEventListener("click", function (e) {
    if (!drawer) return;

    if (
      drawer.classList.contains("active") &&
      !drawer.contains(e.target) &&
      !e.target.closest(".custom-menu-toggle")
    ) {
      drawer.classList.remove("active");
    }
  });

});
// mobileDrawer js end


window.ftRemoveOpen = function(navItem){

  navItem.classList.remove('open');

  document.querySelectorAll('.ft-panel').forEach(function (p) {
    p.style.display = 'none';
  });

};


/* RK 2026-10-20: the mega panel closes as soon as the cursor leaves the white box.
   .ft-panel is a full-width fixed strip (left:0; right:0), so the empty space either side of the white box
   counted as "inside the panel" and kept it open. Now only the white box (.ft-panel-inner) catches the
   pointer; leaving it closes at once, unless the cursor goes back up onto the header bar, where the menu
   item under it opens its own panel as before. */
(function () {
  var st = document.createElement('style');
  st.textContent = '.header-mega-menu-newdesktop .ft-panel{pointer-events:none}' +
    '.header-mega-menu-newdesktop .ft-panel-inner{pointer-events:auto}';
  document.head.appendChild(st);
  document.addEventListener('mouseout', function (e) {
    var inner = e.target.closest && e.target.closest('.ft-panel-inner');
    if (!inner) return;
    var to = e.relatedTarget;
    if (to && (inner.contains(to) || (to.closest && to.closest('.header-mega-menu-newdesktop') && !to.closest('.ft-panel')))) return;
    if (window.ftKeepPanel) window.ftKeepPanel();
    document.querySelectorAll('.ft-panel').forEach(function (p) { p.style.display = 'none'; });
    document.querySelectorAll('.ni').forEach(function (n) { n.classList.remove('open'); });
  });
})();
